import { useEffect, useRef } from "react";
import Config from "../../core/config";
import { makeRequest } from "../../core/services/v1/request";
import CryptoJS from 'crypto-js';
const SECRET_KEY = Config.ENCKEY;

export default function TelegramLogin({ type = '', handleAuthTele = () => { }, children }) {
  const tgRef = useRef(null);

  useEffect(() => {
    window.onTelegramAuth = async function (user) {
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify({ data: user, telegramId: user?.id, provider: 'telegram' }),
        SECRET_KEY,
      ).toString()
      const params = {
        url: `${Config.V1_API_URL}user/${type}`,
        method: 'POST',
        data: { data: encryptedData },
      }
      const sendAuhthData = await makeRequest(params)
      handleAuthTele(sendAuhthData)
    };

    if (tgRef.current.innerHTML) return;

    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?22";
    script.async = true;
    script.setAttribute("data-telegram-login", "uniticexchange_bot");
    script.setAttribute("data-size", "large");
    script.setAttribute("data-userpic", "false");
    script.setAttribute("data-onauth", "onTelegramAuth(user)");

    tgRef.current.appendChild(script);
    
    return () => {
      delete window.onTelegramAuth;
    };
  }, []);

  if (type !== 'register-web' && type !== 'login') {
    return <></>
  }

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <div
        ref={tgRef}
        style={{
          position: "absolute",
          inset: 0,
          opacity: 0,
          zIndex: 10,
        }}
      />
      {children}
    </div>
  );
}